import '../httpservices/core/ajax.httpservice.core';

class ReferenceDataHttpService {

    GetCountries() {
        return $.get('api/ReferenceData/GetCountries');
    }

    GetCountriesDropDown() {
        return $.get('api/ReferenceData/GetCountriesDropDown');
    }

    GetUSStates() {
        return $.get('api/ReferenceData/GetUSStates');
    }

    GetUSStatesDropDown() {
        return $.get('api/ReferenceData/GetUSStatesDropDown');
    }

    GetNyCounties() {
        return $.get('api/ReferenceData/GetNyCounties');
    }

    GetNyCountiesDropDown() {
        return $.get('api/ReferenceData/GetNyCountiesDropDown');
    }

    GetEnrollSource() {
        return $.get('api/ReferenceData/GetEnrollSource');
    }

    GetCounselor() {
        return $.get('api/ReferenceData/GetCounselor');
    }

    GetComposeMessageSubject(areaId) {
        return $.get('api/ReferenceData/GetComposeMessageSubject/' + areaId);
    }

}

export const ReferenceDataHttpSvc = new ReferenceDataHttpService();